import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  const handleProceed = () => {
    if (checked) {
      navigate("/register"); // route to registration page
    }
  };

  const handleQuit = () => {
    navigate("/"); // route to your landing page
  };

  return (
    <div className="container my-4" style={{ fontFamily: "sans-serif" }}>
      <h2 className="text-center mb-4">
        Terms and Conditions of Using Afrogebeya Platform
      </h2>

      {/* Scrollable Terms Box */}
      <div
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          border: "1px solid #ccc",
          padding: "1rem",
          borderRadius: "6px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <p>
          These terms and conditions govern the use of the{" "}
          <strong>afrogebeya.com</strong> e-commerce platform operated by
          Afrogebeya Technologies PLC. You accept the terms and conditions by
          selecting <strong>“Agree”</strong> during registration or checkout
          immediately. If you don’t agree, select <strong>“Quit”</strong> and
          refrain from using the platform.
        </p>

        <h4>1. Definitions</h4>
        <ul>
          <li>
            <strong>Customer/Buyer:</strong> any individual or entity purchasing
            products or services via afrogebeya.com.
          </li>
          <li>
            <strong>Customer account:</strong> An account registered with a
            valid phone number, email, and password used to interact with
            sellers and receive services.
          </li>
          <li>
            <strong>Vendor/Seller:</strong> Any licensed individual, business,
            or entity that has entered into an agreement with Afrogebeya
            Technologies PLC to sell goods or services.
          </li>
          <li>
            <strong>Product Page:</strong> A unified catalog entry where
            identical, similar or different products from multiple sellers are
            displayed for customer comparison.
          </li>
          <li>
            <strong>Escrow Account:</strong> A secure account (via Telebirr,
            bank, or other approved payment providers) where payments are held
            until buyer confirms receipt.
          </li>
          <li>
            <strong>Standard Delivery:</strong> Delivery completed within 1–10
            days depending on regional coverage.
          </li>
          <li>
            <strong>Express Delivery:</strong> Delivery completed within 3–12
            hours in Addis Ababa and regional cities for orders placed before 4
            PM.
          </li>
          <li>
            <strong>Telebirr/Mobile Money:</strong> Mobile money service
            integrated with afrogebeya.com for payment processing.
          </li>
          <li>
            <strong>We / The Platform:</strong> afrogebeya.com operated by
            Afrogebeya Technologies PLC.
          </li>
          <li>
            <strong>You:</strong> the user (either a customer or seller)
            accessing or transacting on afrogebeya.com.
          </li>
        </ul>

        {/* Continue with sections 2–11 as in your terms text */}
        <h4>2. Acceptance of the Terms</h4>
        <p>
          By registering and using the Afrogebeya Platform, you agree to comply
          with these Terms...
        </p>

        <h4>3. Activation and Account Use</h4>
        <p>
          To use Afrogebeya Platform you must be at least 18 years old, register
          with accurate info...
        </p>

        <h4>4. Product availability and listing</h4>
        <ul>
          <li>
            Sellers are responsible for accurate product descriptions, pricing,
            images, and stock levels.
          </li>
          <li>
            Duplicate products (same items listed by multiple sellers) will
            appear under a product page. Customers may choose vendors based on
            price, ratings, and delivery time.
          </li>
          <li>
            Afrogebeya Platform may suspend or remove listings that are
            misleading, inaccurate, or violate prohibited-item rules.
          </li>
          <li>
            Availability may change at any time due to seller stock updates.
          </li>
        </ul>

        <h4>5. Payments and Escrow</h4>
        <ul>
          <li>
            All payments are processed through the Afrogebeya Platform escrow
            system.
          </li>
          <li>
            Buyers pay into escrow and funds are released to seller only after
            delivery confirmation or the expiry of the auto-confirmation period
            (5 days post-delivery)
          </li>
          <li>
            Afrogebeya Platform deducts a platform commission and any applicable
            transaction fees before payout.
          </li>
          <li>
            Refunds are issued to the buyer’s original payment method in cases
            of seller cancellation, non-delivery, or successful dispute
            resolution in favor of the buyer.
          </li>
        </ul>

        <h4>6. Shipping and delivery</h4>
        <ul>
          <li>
            Sellers must ship products within the promised timeframe (standard
            or express).
          </li>
          <li>
            Standard Delivery: 1 day within the same city, 1–10 days cross
            regional.
          </li>
          <li>
            Express Delivery: Within 2–12 hours in Addis Ababa and regional
            cities if ordered before 4 PM.
          </li>
          <li>
            Customers must provide accurate delivery addresses. Afrogebeya.com
            is not liable for failed deliveries due to incorrect addresses.
          </li>
          <li>
            Uncollected items will incur 1% daily storage fees max 500 ETB after
            5 days post-delivery. Afrogebeya Platform reserves the right to
            dispose of unclaimed goods.
          </li>
        </ul>

        <h4>7. Returns and Refunds</h4>
        <ul>
          <li>
            Non-perishable items: returnable within 7 days of receipt if
            defective, damaged, wrong items or without reason.
          </li>
          <li>
            Perishable items: non-returnable unless spoiled at the time of
            delivery.
          </li>
          <li>
            Products must be returned in original packaging and condition.
          </li>
          <li>
            Buyer bears return shipping costs unless the error is
            vendor-related.
          </li>
          <li>
            If sellers fail to resolve return requests within 48 hours,
            Afrogebeya Platform will step in and may impose penalties.
          </li>
        </ul>

        <h4>8. Disputes and Negotiation</h4>
        <ul>
          <li>Non-delivery</li>
          <li>Wrong items</li>
          <li>Seller misconduct</li>
          <li>Damaged product</li>
        </ul>
        <p>
          Afrogebeya.com provides a dispute resolution center to mediate.
          Outcomes may include refund approval, replacement shipment, seller
          penalties (warning, fines, suspension). Fraudulent customers (false
          claims, abuse of returns) may be blacklisted.
        </p>

        <h4>9. Privacy and user conduct</h4>
        <ul>
          <li>
            Afrogebeya Platform collects and uses customer/seller data to
            improve services, in compliance with data privacy laws.
          </li>
          <li>
            Users must not engage in fraudulent or illegal activities; must not
            upload prohibited products (weapons, illegal drugs, counterfeit
            goods, culturally sensitive items); must respect platform rules and
            other users.
          </li>
          <li>
            Violation may result in account suspension, fines, or legal action.
          </li>
        </ul>

        <h4>10. Intellectual property and liability</h4>
        <ul>
          <li>
            All Afrogebeya trademarks, platform content, and branding belongs to
            Afrogebeya Technologies PLC.
          </li>
          <li>
            Sellers retain ownership of their product data but grant Afrogebeya
            the right to display and market products on the platform.
          </li>
          <li>
            Afrogebeya only takes responsibility for the transaction within its
            control but is not liable for indirect, incidental, or consequential
            damages caused by any other platform.
          </li>
        </ul>

        <h4>11. Governing Law</h4>
        <ul>
          <li>These terms are governed by the laws of Ethiopia.</li>
          <li>
            Dispute shall first be attempted through negotiation and mediation
            via Afrogebeya Platform dispute resolution center.
          </li>
          <li>
            If unresolved, dispute will be preferred to Ethiopian courts with
            proper jurisdiction.
          </li>
          <li>
            Afrogebeya is not liable for non-performance due to force majeure
            events (Natural disasters, war, strikes, system outages).
          </li>
        </ul>
      </div>

      {/* Checkbox */}
      <div className="form-check mt-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="agreeCheck"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="agreeCheck">
          I have read and I agree to the Terms and Conditions
        </label>
      </div>

      {/* Action buttons */}
      <div className="d-flex justify-content-center gap-3 mt-3">
        <button
          className="btn btn-primary"
          disabled={!checked}
          onClick={handleProceed}
        >
          Proceed to Registration
        </button>
        <button className="btn btn-outline-danger" onClick={handleQuit}>
          Quit
        </button>
      </div>
    </div>
  );
};

export default Terms;
